import { Link } from 'react-router-dom';

import { PATH } from '../widget-lib/path-routes';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';

export default function NotFoundPage() {
  useWidgetSeo('Страница не найдена (404)');
  return (
    <div className="space-y-4 w-full min-w-0">
      <h1 className="text-xl font-semibold tracking-tight">Страница не найдена</h1>
      <p className="text-sm text-[var(--text-muted)]">Проверьте адрес или вернитесь на главную.</p>
      <Link className="text-sm font-medium text-[var(--accent)]" to={PATH.home}>
        На главную
      </Link>
    </div>
  );
}
